import { AfterViewInit, Component, Inject, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CloseDesignerDialogComponent
       } from 'app/dialogs/close-designer-dialog/close-designer-dialog.component'; // eslint-disable-line
import { Button } from 'app/dialogs/dialog-buttons.component';

import { NavigationLink } from 'app/product-designer-component-config';
import { ProductConfig } from 'app/product-designer-config';
import { ProgressService } from 'app/progress/progress.service';
import { ToolboxService } from 'app/toolboxes/toolbox.service';
import { DesignStepService
       } from 'collage-designer/design-step/design-step.service';
import { ProductService } from 'core/product/product.service';
import { Utils } from 'core/utils';
import { AsyncEventEmitterSubscriber
       } from 'core/utils/async-event-emitter';
import { Subscription } from 'rxjs';

@Component({
  selector: 'top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  standalone: false
})
export class TopBarComponent implements OnDestroy, AfterViewInit
{
  public displayProductChooser: boolean = false;
  public isFirstDesignStep: boolean = true;
  public productName: string = '';
  public activeToolbox: string|undefined;

  private subscriptions: Subscription = new Subscription();
  private producthasChangedSubscription:
      AsyncEventEmitterSubscriber<ProductConfig>;

  public constructor(
      private dialog: MatDialog,
      @Inject(DesignStepService) private designStepService: DesignStepService,
      @Inject(ProductService) private productService: ProductService,
      @Inject(ToolboxService) private toolboxService: ToolboxService,
      @Inject(ProgressService) private progressService,
  )
  {
    this.displayProductChooser = this.productService.getProducts().length > 1;

    this.subscriptions.add(
        this.toolboxService.targetChanged.subscribe(() => {
          this.activeToolbox = this.toolboxService.getActiveToolboxName(
              'top-bar');
        }));

    this.isFirstDesignStep = this.designStepService.getDesignStepId() === 0;
    this.subscriptions.add(
        this.designStepService.designStepChanged.subscribe(() => {
          this.isFirstDesignStep =
              this.designStepService.getDesignStepId() === 0;
        }));
  }

  public ngAfterViewInit(): void
  {
    this.producthasChangedSubscription =
        this.productService.productHasChanged.subscribe(
            async (productConfig) => {
          this.productName = productConfig.name;
        });
  }

  public ngOnDestroy(): void
  {
    this.subscriptions.unsubscribe();
    this.productService.productHasChanged.unsubscribe(
        this.producthasChangedSubscription);
  }

  public backButtonClicked(event: Event): void
  {
    this.dialog.open(CloseDesignerDialogComponent, {
      data: {},
      panelClass: 'dialog-pane',
      disableClose: true,
    }).afterClosed().subscribe(result => {
      if (result === Button.Choice.CONTINUE) {
        this.progressService.abortDesigner('back');
      }
    });
  }

  public openProductChooser(): void
  {
    if (this.displayProductChooser && this.isFirstDesignStep) {
      this.toolboxService.toggle('ProductChooserToolbox');
    }
  }
}
